<template>
  <div class="pentagonWrapper">
    <div class="pentagon" :class="[statusCssClass]"></div>
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: "pentagon",
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    // 获取状态css类
    statusCssClass() {
      let cssClass = "";
      if (this.status == 0) {
        cssClass = "noStart"; // 未开始
      } else if (this.status == 1) {
        cssClass = "onGoing"; // 进行中
      } else if (this.status == 2) {
        cssClass = "over"; // 已结束
      } else if (this.status == 3) {
        cssClass = "over"; // 已取消
      }
      return cssClass;
    },
    title() {
      let title = "";
      if (this.status == 0) {
        title = "未开始"; // 未开始
      } else if (this.status == 1) {
        title = "进行中"; // 进行中
      } else if (this.status == 2) {
        title = "已结束"; // 已结束
      } else if (this.status == 3) {
        title = "已取消"; // 已取消
      }
      return title;
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.pentagonWrapper {
  position: relative;
  top: -3px;
  h3 {
    height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    text-align: center;
    position: absolute;
    top: 10px;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .pentagon {
    width: 0;
    height: 0;
    border: 55px solid #58abf6;
    border-bottom: 0px solid #58abf6 !important;
    position: relative;
  }

  .pentagon:after {
    content: "";
    width: 0;
    height: 0;
    border-top: 20px solid #58abf6 !important;
    border: 55px solid transparent;
    position: absolute;
    top: 0px;
    left: -53px;
  }

  .noStart {
    border: 55px solid #c7ced9;
    border-bottom: 0px solid #c7ced9 !important;
  }

  .noStart:after {
    border-top: 20px solid #c7ced9 !important;
  }
  .over {
    border: 55px solid #ff9f00;
    border-bottom: 0px solid #ff9f00 !important;
  }

  .over:after {
    border-top: 20px solid #ff9f00 !important;
  }
}
</style>
